export default {
    PARTICIPANTS: {
        CHECKING_LIST: 'participants.checkingList',
        SERVICE_ENROLLMENT: 'participants.serviceEnrollment'
    },
    SERVICE: {
        SCHEDULED_LIST: 'service.scheduledList'
    }
};
